import { render, staticRenderFns } from "./unionMemberStaffs.vue?vue&type=template&id=529029f2&"
import script from "./unionMemberStaffs.vue?vue&type=script&lang=js&"
export * from "./unionMemberStaffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "unionMemberStaffs.vue"
export default component.exports